<div resizeObserver (resizeEvent)="onHeaderResize($event)" role="main">
  <rv-draggable [draggableService]="draggableService">
    @if (allowUpload) {
      <upload
        #upload
        [folderPath]="folderPath"
        [getExistingFiles]="list"
        (addFile)="reloadList()"
        (queueLengthChange)="uploadQueueLength = $event"
      ></upload>
    }
    @let error = listState.error() | async;
    <div
      [shown]="error?.apiError"
      class="madero-style alert alert-danger text-center"
      role="alert"
    >
      <p><strong>Something went wrong</strong></p>
      {{ error?.apiError }}
      <div>
        If the problem persists, please
        <a
          class="madero-link"
          actionLink
          (click)="helpWidgetService.showContactUs()"
          >Contact Us</a
        >.
      </div>
    </div>
    <div
      class="tw-flex tw-flex-col md:!tw-flex-row tw-pb-8 tw-px-6 tw-gap-5 tw-items-center"
    >
      <search-filter
        #searchFilter
        class="w-100"
        [filterConfig]="filterConfig"
        [search]="search"
        [doSearch]="search.doSearch"
        [localSearch]="true"
        [focus]="true"
      />
      @if (allowUpload) {
        <div
          class="search-buttons tw-gap-4"
          [ngClass]="{ disabled: isTrashFolder }"
        >
          <button
            type="button"
            class="tw-min-w-64"
            tabindex="0"
            id="newFolderButton"
            matButton="outlined"
            (click)="createFolder()"
            [disabled]="isTrashFolder"
          >
            <mat-icon svgIcon="add-folder" aria-hidden="true" /> Create Folder
          </button>
          <button
            type="button"
            class="tw-min-w-64"
            tabindex="0"
            matButton="outlined"
            id="uploadFolderButtonUnsubscribed"
            (click)="currentPlanService.showUnlockThisFeatureModal()"
            [hidden]="currentPlanService.isPlanActive()"
          >
            <mat-icon svgIcon="upload" aria-hidden="true" /> Upload Folder
          </button>
          <button
            type="button"
            class="tw-min-w-64"
            tabindex="0"
            matButton="outlined"
            id="uploadFolderButton"
            (click)="uploadComponent?.openFolderSelector()"
            [shown]="currentPlanService.isPlanActive()"
          >
            <mat-icon svgIcon="upload" aria-hidden="true" /> Upload Folder
          </button>
          <button
            type="button"
            class="tw-min-w-64"
            tabindex="0"
            id="uploadButtonUnsubscribed"
            mat-flat-button
            color="primary"
            (click)="currentPlanService.showUnlockThisFeatureModal()"
            [hidden]="currentPlanService.isPlanActive()"
          >
            <mat-icon svgIcon="upload" /> Upload Files
          </button>
          <button
            type="button"
            class="tw-min-w-64"
            tabindex="0"
            id="uploadButton"
            mat-flat-button
            color="primary"
            (click)="uploadComponent?.openFileSelector()"
            [shown]="currentPlanService.isPlanActive()"
          >
            <mat-icon svgIcon="upload" /> Upload Files
          </button>
        </div>
      }
    </div>
    <mat-divider class="light" />
    <div
      class="tw-flex tw-flex-row tw-p-6 tw-min-w-0 tw-max-w-full"
      [shown]="isFileListVisible()"
    >
      <div
        class="flex-row-entry flex-grow tw-flex tw-items-center tw-min-w-0 tw-overflow-hidden"
      >
        <folder-path
          [folderPath]="folderPath"
          (folderClicked)="
            changeFolder({
              item: { name: $event, kind: 'folder' },
              isFolder: false,
              selected: false,
            })
          "
        ></folder-path>
      </div>
      @if (
        storageService.isMultipleSelector(storageFull, selectorType) &&
        !allowBatchOperations &&
        listState.getSelected().length
      ) {
        <div class="flex-row-entry pr-4">
          {{ listState.getSelected().length }} Selected
        </div>
      }
      <div
        class="flex-row-entry"
        [shown]="listState.filesDetails.bucketExists && allowUpload"
      >
        <list-grid-toggle
          [(isListView)]="isListView"
          (isListViewChange)="isListViewChange.emit($event)"
        ></list-grid-toggle>
      </div>
    </div>
    <div
      id="files-toolbar"
      class="flex-row"
      [hidden]="fileListStatus.code === 404"
    >
      @if (allowBatchOperations && listOperations?.operations?.length) {
        <batch-actions
          styles="xl:!tw-mr-[288px] xl:!tw-min-w-[725px]"
        ></batch-actions>
      }
    </div>
    <mat-divider class="light" />
    <div
      class="tw-px-3.5 files-list-container"
      #filesListContainer
      rvSpinner="storage-selector-loader"
      [rvShowSpinner]="loadingItems()"
    >
      @if (!loadingItems() && list().length) {
        @if (isListView) {
          <cdk-virtual-scroll-viewport
            [itemSize]="68"
            class="scrollable-list horizontal-scroll rounded-rows"
            appendOnly
          >
            <storage-list-view
              [files]="list()"
              [folderPath]="folderPath"
              [filesDetails]="listState.filesDetails"
              [fileListVisible]="isFileListVisible()"
              [search]="search"
              [isAllSelected]="listState.isAllSelected()"
              (selectAll)="selectAll()"
              (fileClick)="onFileClick($event)"
              (fileSelect)="onFileSelect($event)"
              [listOperations]="listOperations.operations"
              (operationClick)="handleOperationClick($event)"
              [selectorType]="selectorType"
              [selectorFilter]="selectorFilter"
              [storageFull]="storageFull"
            >
            </storage-list-view>
          </cdk-virtual-scroll-viewport>
        } @else {
          <div class="tw-py-6 horizontal-scroll grid-selector">
            <storage-grid-view
              #storageGridView
              [files]="list()"
              [folderPath]="folderPath"
              [filesDetails]="listState.filesDetails"
              [fileListVisible]="isFileListVisible()"
              [search]="search"
              [isEmpty]="!loadingItems() && isEmptyState()"
              (fileClick)="onFileClick($event)"
              (fileSelect)="onFileSelect($event)"
              (uploadFiles)="uploadComponent?.openFileSelector()"
              [listOperations]="listOperations.operations"
              (operationClick)="handleOperationClick($event)"
              [selectorType]="selectorType"
              [selectorFilter]="selectorFilter"
              [storageFull]="storageFull"
            >
            </storage-grid-view>
          </div>
        }
      }
    </div>
  </rv-draggable>
</div>
